const test =  {
    "harvest": {
        name: "Harvest Eocrypto REUNION",
        description: "Harverst Eocrypto utilise l'énergie du vent pour miner de la crypto_monnaie et plus précisément notre chère BourbonCoin",
        currentInvestement: 951_127,
        isSponsorised: true
    },
    "crypto_volcanic": {
        name: "Crypto Volcanic",
        description: "Crypto Volcanic en partenariat avec EDF utilise la chaleur thermique de notre chère volcan afin d'alimenter leur ferme de BourbonCoin",
        currentInvestement: 348_995,
        isSponsorised: false,
    }
}
export default test